import React, { useEffect, useRef, useState } from 'react';
import { css } from '@emotion/react';
import { FullWidthText } from '@/customTypes/chatStory';
import { getTextEffectStyle } from '@service/ChapterService';

interface ITextWithEffect {
  fullWidthText: FullWidthText;
}

const TextWithEffect = ({ fullWidthText }: ITextWithEffect) => {
  const textElementRef = useRef<HTMLSpanElement>(null);
  const [fontSize, setFontSize] = useState<number>();

  useEffect(() => {
    if (!textElementRef.current) return;

    const computedStyle = window.getComputedStyle(textElementRef.current);
    // 폰트사이즈(ex)16px)문자열 끝의 "px"문자 제거, 숫자로 변환
    const fontSize = Number(
      computedStyle.getPropertyValue('font-size').replace(/px$/, ''),
    );

    setFontSize(fontSize);
  }, []);

  return (
    <>
      {fullWidthText.messageWithEffect ? (
        fullWidthText.messageWithEffect.map((item, index) => {
          const fontStyleCSS = getTextEffectStyle({
            style: item.style,
            currentSize: fontSize,
            sizeOffset: item.fontSizeOffset,
          });

          return (
            <span
              ref={textElementRef}
              key={`${item.text}_${index}`}
              css={css`
                white-space: pre-line;
                color: ${item.color};
                ${fontStyleCSS}
              `}
            >
              {item.text}
              {(fullWidthText.messageWithEffect?.length || 0) - 1 > index && (
                <>&nbsp;</>
              )}
            </span>
          );
        })
      ) : (
        <span>{fullWidthText?.message || ''}</span>
      )}
    </>
  );
};

export default TextWithEffect;
